/*
 * @Author: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @Date: 2022-10-25 14:47:03
 * @LastEditors: GRANDSOFT\chenz-k chenz-k@glodon.com
 * @LastEditTime: 2022-11-07 10:37:52
 * @FilePath: \shared-portal-web\packages\login\src\api\landing.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/request' // 导入http中创建的axios实例
import { dcostUrl } from '@/config'
// import { encode } from 'querystring'
// const headers = {
//   'Content-Type': 'application/x-www-form-urlencoded'
// }

/**
 * 合作伙伴
 * */

// 获取合作伙伴列表
export const getPartnerList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/partner`, params)
}

/**
 * 轮播图
 * */

// 获取轮播图列表
export const getBannerList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/banner`, params)
}

/**
 * 解决方案
 * */

// 获取解决方案列表
export const getSolutionList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/solution`, params)
}

/**
 * 视频介绍
 * */

// 获取视频介绍列表
export const getVideoList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/video`, params)
}

/**
 * 应用标杆案例
 * */

// 获取应用标杆案例列表
export const getBenchmarkCaseList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/benchmark_case`, params)
}

/**
 * 底部链接
 * */

// 获取底部链接列表
export const getBottomLinkList = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/bottom_link`, params)
}

/**
 * 购买咨询
 * */

// 添加购买咨询信息
export const addConsult = (params) => {
  return request.post(`${dcostUrl}/web_config/landing_page/bottom_link/consult?company=${params.company}&name=${params.name}&phone=${params.phone}&region=${params.region}`)
}

/**
 * 应用案例
 * */

// 查询应用案例
export const getApplication = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/application_case?pageNum=${params.pageNum || ''}&pageSize=${params.pageSize || ''}&solutionId=${params.solutionId || ''}`)
}

/**
 * 平台动态
 * */

// 查询平台动态
export const getNews = (params) => {
  return request.get(`${dcostUrl}/web_config/landing_page/platform_news?pageNum=${params.pageNum || ''}&pageSize=${params.pageSize || ''}`)
}
